import PropTypes from 'prop-types';
import { screen } from 'components/styles/variables';

export default function ScrollingCarousel({ items, ItemComponent, children }) {
  return (
    <div
      className="scrolling-carousel"
      aria-label="carousel"
      role="contentinfo"
    >
      <ul>
        {children ||
          items.map((item) => <ItemComponent key={item.key} {...item} />)}
      </ul>
      <style jsx>{`
        ul {
          list-style: none;
          padding: 0;
          margin: 0;
          width: 1221px;
        }

        @media (min-width: ${screen.smMin}) {
          ul {
            width: auto;
          }
        }

        .scrolling-carousel {
          overflow-x: scroll;
          overflow-y: hidden;
          -webkit-overflow-scrolling: touch;
          height: 300px;
        }

        @media (min-width: ${screen.smMin}) {
          .scrolling-carousel {
            overflow-x: visible;
            overflow-y: visible;
          }
        }
      `}</style>
    </div>
  );
}
ScrollingCarousel.propTypes = {
  items: PropTypes.array,
  ItemComponent: PropTypes.elementType,
  children: PropTypes.node,
};
